import m from "../../geodata/es2015/djiboutiHigh";
window.am4geodata_djiboutiHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/djiboutiHigh.js
// module id = null
// module chunks = 